<template lang="pug">
    apexchart.apexchart(height="350" width="98%" type="bar" :options="options" :series="series")
</template>

<script>
export default {
  name: 'BarChartDashboard',
  props: {
    series: {
      type: Array,
      default: () => ([])
    },
    categories: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    options: function () {
      return {
        chart: {
          type: 'bar',
          height: 350
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            borderRadius: 10
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: this.categories
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: this.formatter
          }
        },
        colors: ['#ff7b00', '#28c868']
      }
    }
  }
}
</script>
